import get from "lodash/get"
import set from "lodash/set"
import at from "lodash/at"

export function useApiHelper() {
  const baseStore = useBaseStore()
  const currentPage = computed(() => baseStore.currentPage)
  const result = ref({})

  function setCurrentPage(page) {
    baseStore.$patch({ currentPage: page })
  }

  function resetCache() {
    baseStore.$patch({ apiCache: {} })
  }

  async function getCompany({ companyId, locale }) {
    const address = `getCompany.${currentPage.value}.${companyId}.${locale}`
  
    if (!get(result.value, address)) {
      try {
        const response = await usePost("/company/q", {
          companyId,
          locale,
        })
        set(result.value, address, response?.data.data ?? null)
      } catch (e) {
        set(result.value, address, null)
      }
    }
  
    return get(result.value, address)
  }
  async function getYarnStatistic({
    yarnId,
    locale,
    fromDate = null,
    toDate = null,
  }) {
    const address = `getYarnStatistic.${currentPage.value}.${yarnId}.${locale}.${fromDate}${toDate}`;
    return fetchWithCache(address, async () => {
      try {
        const [downloadedTime, favoriteTime, viewedTime] = await Promise.all([
          fetchYarnData("/api/download/q/t", {
            yarnId,
            locale,
            fromDate,
            toDate,
          }),
          fetchYarnData("/api/favorite/q/t", {
            yarnId,
            locale,
            fromDate,
            toDate,
          }),
          fetchYarnData("/api/viewed/q/t", {
            yarnId,
            locale,
            fromDate,
            toDate,
          }),
        ]);
        return { downloadedTime, viewedTime, favoriteTime };
      } catch {
        return { downloadedTime: 0, viewedTime: 0, favoriteTime: 0 };
      }
    });
  }

  async function fetchYarnData(url, body) {
    try {
      const response = await usePost(url, {
        body,
      });
      return response?.data?.totalCount ?? 0;
    } catch {
      return 0;
    }
  }

  return { setCurrentPage, resetCache, getCompany, getYarnStatistic };
}
